import React, { memo, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  DropdownMenu,
  DropdownItem,
  Button,
  Text,
} from '@cashfree-intl/coherent';

import { StyledCheckbox, DropdownCTAGroup, StyledDropdown } from '../styled';

const MultiSelectDropdown = ({
  options,
  name,
  setFieldTouched,
  setFieldValue,
  setFieldError,
  placeholder,
  disabled,
  value = [],
}) => {
  // @ts-ignore
  const [openDropdown, setOpenDropdown] = useState(null);

  const dropdownRef = useRef(null);

  const onOptionClick = option => () => {
    // check if already present in selected
    const { value: selectedValue } = option;

    const index = value.findIndex(obj => obj.value === selectedValue);

    let data = JSON.parse(JSON.stringify(value));

    // handle the scenario for ALL option
    if (index > -1) {
      if (selectedValue === 'ALL') {
        data = [];
      } else {
        data.splice(index, 1);
        // remove the ALL if all is present
        if (data.length && data[0].value === 'ALL') {
          data.splice(0, 1);
        }
      }
      setFieldValue(name, data);
    } else {
      if (selectedValue === 'ALL') {
        data = options.filter(o => !o.readOnly);
      } else {
        data.push(option);
      }
      setFieldValue(name, data);
    }
    if (data.length > 0) setFieldError(name, '');
  };

  const onReset = () => {
    // clear every selection and set the values to initial state
    // setSelected([]);
    setFieldValue(name, []);
  };
  const handleOutsideClick = event => {
    if (
      openDropdown &&
      (!openDropdown.contains(event.target) ||
        event.target?.classList?.contains('multiselect-dropdown-save-button'))
    ) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openDropdown]);

  return (
    <StyledDropdown
      disabled={disabled || options.length === 0}
      selection
      ref={dropdownRef}
      placeholder={placeholder}
      icon="chevron down"
      text={value.length > 0 ? `${value.length} selected` : null}
      key={name}
      className={`${name}${value.length > 0 ? ' elements-selected' : ''}`}
      open={
        openDropdown === null
          ? false
          : openDropdown === dropdownRef?.current?.ref?.current
      }
      onClick={() => {
        // @ts-ignore
        setOpenDropdown(dropdownRef.current?.ref?.current);
      }}
      onBlur={() => setFieldTouched(name)}
    >
      <DropdownMenu>
        {options.map((option, index) => (
          <DropdownItem key={option.key} onClick={onOptionClick(option)}>
            <StyledCheckbox
              label={option.text}
              className={index > 0 ? 'ml-2' : ''}
              checked={!!value.find(obj => obj.value === option.value)}
              onClick={e => {
                e.stopPropagation();
                if (!option.readOnly) {
                  onOptionClick(option)(e);
                }
              }}
              readOnly={option.readOnly}
            />
            {option.readOnly && (
              <Text variant="b12" color="warning" className="ml-5 mt-1">
                Recon not supported{' '}
              </Text>
            )}
          </DropdownItem>
        ))}
        <DropdownCTAGroup
          alignItems="center"
          justifyContent="flex-end"
          className="p-2 pb-3"
        >
          <Button secondary type="button" onClick={onReset} size="small">
            Reset
          </Button>
        </DropdownCTAGroup>
      </DropdownMenu>
      {/* ):<></>} */}
    </StyledDropdown>
  );
};

MultiSelectDropdown.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldError: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.array,
};

export default memo(MultiSelectDropdown);
